import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';

$.fancybox.defaults.i18n.ru = {
	CLOSE: 'Закрыть',
	NEXT: 'Следующий',
	PREV: 'Предыдущий',
	ERROR: 'Не удалось загрузить содержимое <br/> Пожалуйста, попробуйте позже.',
	PLAY_START: 'Начать слайдшоу',
	PLAY_STOP: 'Остановить слайдшоу',
	FULL_SCREEN: 'На весь экран',
	THUMBS: 'Предпросмотр'
};

$.fancybox.defaults.lang = LANG;



// WEBPACK FOOTER //
// ./lib/fancybox/index.js